import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import img from "../../../../assets/img/admin/ads.png"
import useFetch from '../../../../hooks/useAxios';
import Button from '../../../shared/Button';



const AdminAds = () => {
    const Data= [...Array(9)]
    const [adsList, setadsList] = useState([]);
  const apiadsList = useFetch({
    method: "get",
    url: "api/admin/ads",
    noHeader: false,
    trigger: true,
    argFunc: res => setadsList(res.data)
  });
  const navigate = useNavigate()
  return (
    <div>
      <div className='flex justify-between items-center mb-[36px]'>
      <h3 className='text-[#12171C] text-[36px] font-[700] '>پنل های تبلیغاتی</h3>
      <Button onClick={()=>navigate("/admin/create-ads")} varient="primary">ساخت پنل تبلیغاتی</Button>
      </div>
      <div className='grid grid-cols-3 gap-[31px]'>
      {
            adsList.map(i=>
                <div>
                    <img width="100%" height={272} src={i.thumbnail?.path}/>
                    <div className='flex justify-between items-center mt-[26px]'>
                        <div className='text-[#292D32] text-[21px] font-[700] '>{i.title}</div>
                        {/* <div className='text-[#00A6A6] Danafont text-[14px] font-[500] '>
                        {} اقامتگاه
                        </div> */}
                    </div>
                </div>)
        }
      </div>
    </div>
  )
}

export default AdminAds